import { InjectionToken } from '@angular/core';

export const BRAND_ASSET_ENDPOINT = new InjectionToken<string>('Brand asset endpoint');
